import React, {useState, useEffect} from 'react';
import { useSelector, useDispatch  } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { Container} from '@material-ui/core';
import { Checkbox } from '@material-ui/core';
import { FormControlLabel } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { MenuItem } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { useFormik } from 'formik';
import * as yup from 'yup';
import axios from 'axios';
import axiosJsonAdapter from 'axios-jsonp';

//component
import Loader from '../components/Loader'

import { headRewrite } from '../function/headRewrite';

import { post_purchase } from '../actions/purchaseAction';
import { baseAxios } from '../jwtInterceptor';

const useStyles = makeStyles((theme) => ({
    agreement:{
        height: '200px',
        backgroundColor: 'white',
        borderRadius: '5px',
        marginBottom: theme.spacing(2),
        overflowY: 'auto'
    },
    agreement_text:{
        whiteSpace: 'pre-line'
    },
    button:{
        color:'black',
        backgroundColor:'white',
        '&:hover':{
            backgroundColor:theme.palette.primary['400']
        }
      },
    error_container:{
        height: '100vh',
        marginTop: theme.spacing(3)
    },
    loader:{
        [theme.breakpoints.down('sm')]:{
            marginTop:'40%',
            textAlign:'center',
            minHeight:'100vh',
        },
        [theme.breakpoints.up('sm')]:{
            marginTop:'25%',
            textAlign:'center',
            minHeight:'100vh',
        },
        [theme.breakpoints.up('md')]:{
            marginTop:'20%',
            textAlign:'center',
            minHeight:'100vh',
        },

    },
    root:{
        [theme.breakpoints.up('xs')]:{
            margin: theme.spacing(1,1,15,1)
        },
        [theme.breakpoints.up('sm')]:{
            margin:theme.spacing(2,2,15,2)
        },
        [theme.breakpoints.up('md')]:{
            margin: theme.spacing(3,15,15,15)
        }
    },
    title:{
        fontWeight:'bold',
        textAlign:'center',
        marginTop: theme.spacing(10),
        marginBottom: theme.spacing(5)
    }
}))

const phoneRegex =/^[0-9]{2,3}?[0-9]{3,4}?[0-9]{3,4}?$/
const postalRegex = /^[0-9]{3}-?[0-9]{4}$/
const MAX_ID_IMAGE_SIZE = 5 * 1024 * 1024
const MAX_ID_IMAGE_TOTAL_SIZE = 10 * 1024 * 1024
const ALLOWED_ID_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp']
const HEIC_IMAGE_TYPES = ['image/heic', 'image/heif', 'image/heic-sequence', 'image/heif-sequence']
const ID_IMAGE_ACCEPT = [...ALLOWED_ID_IMAGE_TYPES, ...HEIC_IMAGE_TYPES, '.heic', '.heif'].join(',')

const calculateAge = (year, month, day) => {
    const today = new Date()
    const birthday = new Date(year, month - 1, day)
    let age = today.getFullYear() - birthday.getFullYear()
    const m = today.getMonth() - birthday.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
        age--;
      }
      return age;
}

//validationschemaをアカウント登録としている方としていない方で分ける必要がある
const validationSchema = yup.object({
    sei: yup
      .string()
      .max(20, '20文字以内で入力して下さい')
      .required('入力は必須です'),
    mei: yup
      .string()
      .max(20, '20文字以内で入力して下さい')
      .required('入力は必須です'),
    first_name: yup
      .string()
      .max(20, '20文字以内で入力して下さい')
      .required('入力は必須です'),
    last_name: yup
      .string()
      .max(20, '20文字以内で入力して下さい')
      .required('入力は必須です'),
    phone_number: yup
      .string()
      .max(20, '20文字以内で入力して下さい')
      .required('電話番号の入力は必須です')
      .matches(phoneRegex, '正しい形式で入力して下さい'),
    email: yup
      .string()
      .email('正しい形式で入力して下さい')
      .required('emailアドレスは必須です'),
    year: yup.string().required('年を選択してください'),
    month: yup.string().required('月を選択してください'),
    day: yup.string().required('日を選択してください'),
    age: yup
      .number()
      .typeError('正しい数値を入力して下さい')
      .integer('正しい形式で入力して下さい')
      .required('年齢は必須です'),
    job: yup
      .string()
      .max(20, '20文字以内で入力して下さい')
      .required('職業の入力は必須です'),
    prefecture: yup
      .string()
      .max(20, '20文字以内で入力して下さい')
      .required('現住所の都道府県入力は必須です'),
    region: yup
      .string()
      .max(250, '250文字以内で入力して下さい')
      .required('現住所の市町村区入力は必須です'),
    address_line: yup
      .string()
      .max(250, '250文字以内で入力して下さい')
      .required('番地の入力は必須です'),
    building_name: yup
      .string()
      .max(250, '250文字以内で入力して下さい'),
    postalcode: yup
      .string()
      .matches(postalRegex, '郵便番号は「123-4567」または「1234567」の形式で入力して下さい')
      .required('郵便番号の入力は必須です'),
    agreeToTerms: yup
      .boolean()
      .oneOf([true], '買取規約への同意が必要です'),
    isNotInvoiceIssuer: yup
      .boolean()
      .oneOf([true], 'インボイス登録状況の確認が必要です'),
    idType: yup.string(),
  }).test('adult', '18歳未満はお申込みできません', function (values) {
    const { year, month, day } = values;
    if (!year || !month || !day) return false;
    return calculateAge(parseInt(year), parseInt(month), parseInt(day)) >= 18;
  })

const ID_TYPE_OPTIONS = [
    { key: 'driver_license', label: '運転免許証' },
    { key: 'my_number', label: 'マイナンバーカード' },
    { key: 'passport', label: 'パスポート' },
    { key: 'resident_card', label: '在留カード' },
];

const JOB_OPTIONS = [
    {key: 'office_worker', label: '会社員'},
    {key: 'goverment_employee', label: '公務員'},
    {key: 'self_employee', label: '自営業'},
    {key: 'executive', label: '会社役員'},
    {key: 'apparel', label: 'アパレル関係'},
    {key: 'artist', label: 'アーティスト'},
    {key: 'stylist', label: 'スタイリスト'},
    {key: 'freeter', label: 'フリーター'},
    {key: 'student', label: '学生'},
    {key: 'unemployed', label: '無職'},
    {key: 'others', label: 'その他'}
]

 
function KaitoriFormScreen(){
    const classes = useStyles()
    const dispatch = useDispatch()

    const title = "ブランド服・古着高価買取｜Enclopedia（アンクロペディア）"
    const description = "ブランド服の買取はEnclopediaへ。不要になったブランド服・古着を高価買取させて頂きます。"
    const keyword = ""

  const [frontId, setFrontId] = useState(null);
  const [backId, setBackId] = useState(null);
  const [frontIdError, setFrontIdError] = useState('');
  const [backIdError, setBackIdError] = useState('');
  const [nameMismatchError, setNameMismatchError] = useState('');
  const [identityInfo, setIdentityInfo] = useState({
    document_required: true,
    note: '本人確認書類をご提出ください。'
  });
  const [identityBaseline, setIdentityBaseline] = useState(null);
  const [convertingImageSide, setConvertingImageSide] = useState(null);
  const [postalLookupLoading, setPostalLookupLoading] = useState(false);
  const [postalLookupError, setPostalLookupError] = useState('');

    const { accountInfo } = useSelector(state => state.account)
    const { accountPublicInfo } = useSelector(state => state.accountPublicInfo)
    const {adressInfo} = useSelector(state => state.adress)
    const {purchase, loading, error} = useSelector(state => state.purchase)

    const handleIdentityImageChange = async (side, event) => {
      const input = event.currentTarget
      let file = input.files && input.files[0]
      const otherFile = side === 'front' ? backId : frontId
      const setFile = side === 'front' ? setFrontId : setBackId
      const setFileError = side === 'front' ? setFrontIdError : setBackIdError

      if (!file) {
        setFile(null)
        setFileError('')
        return
      }
      const isHeic = HEIC_IMAGE_TYPES.includes(file.type) || /\.(heic|heif)$/i.test(file.name)
      if (isHeic) {
        setFile(null)
        setFileError('')
        setConvertingImageSide(side)
        try {
          const {default: heic2any} = await import('heic2any')
          const converted = await heic2any({blob: file, toType: 'image/jpeg', quality: 0.9})
          const convertedBlob = Array.isArray(converted) ? converted[0] : converted
          const jpegName = file.name.replace(/\.(heic|heif)$/i, '') + '.jpg'
          file = new File([convertedBlob], jpegName, {
            type: 'image/jpeg',
            lastModified: file.lastModified,
          })
        } catch (conversionError) {
          setFileError('HEIC・HEIF画像をJPEGへ変換できませんでした。画像をJPEGとして保存し直してから選択してください。')
          input.value = ''
          return
        } finally {
          setConvertingImageSide(null)
        }
      }
      if (!ALLOWED_ID_IMAGE_TYPES.includes(file.type)) {
        setFile(null)
        setFileError('JPEG・PNG・WebP形式の画像を選択してください。')
        input.value = ''
        return
      }
      if (file.size > MAX_ID_IMAGE_SIZE) {
        setFile(null)
        setFileError('画像ファイルが大きすぎます。1枚5MB以下になるよう、画像を縮小または圧縮してから再度選択してください。')
        input.value = ''
        return
      }
      if (file.size + (otherFile ? otherFile.size : 0) > MAX_ID_IMAGE_TOTAL_SIZE) {
        setFile(null)
        setFileError('本人確認画像は表裏合計10MB以下になるよう、画像を縮小または圧縮してください。')
        input.value = ''
        return
      }
      setFile(file)
      setFileError('')
    }

    const hasIdentityImageError = Boolean(frontIdError || backIdError)

    // 追加バリデーション: 口座情報（必須）
    const formSchema = validationSchema.shape({
        bank_name: yup
          .string()
          .max(100, '100文字以内で入力してください')
          .required('銀行名は必須です'),
        branch_name: yup
          .string()
          .max(100, '100文字以内で入力してください')
          .required('支店名は必須です'),
        account_type: yup
          .string()
          .oneOf(['futsu', 'toza'], '口座種別を選択してください')
          .required('口座種別は必須です'),
        account_number: yup
          .string()
          .matches(/^\d{7}$/, '口座番号は7桁の数字で入力してください')
          .required('口座番号は必須です'),
        account_holder: yup
          .string()
          .matches(/^[ァ-ヶー\u3000]+$/, '口座名義は全角カタカナで入力してください')
          .required('口座名義は必須です'),
        line_appraisal_code: yup
          .string()
          .max(30, '30文字以内で入力してください')
          .matches(/^[0-9０-９\s\u3000]*$/, 'LINE査定コードは数字で入力してください'),
    })

    const formik = useFormik({
        initialValues: {
          sei: '',
          mei: '',
          first_name: accountPublicInfo?.first_name || '',
          last_name: accountPublicInfo?.last_name || '',
          email: accountPublicInfo?.email || '',
          phone_number: accountPublicInfo?.phone_number || '',
          year: '',
          month: '',
          day: '',      
          age: '',
          job: '',
          prefecture: adressInfo?.prefecture || '',
          region: adressInfo?.region || '',
          address_line: '',
          building_name: '',
          postalcode: adressInfo?.postalcode || '',
          delivery_method: 'A',
          delivery_day: '',
          agreeToTerms: false,
          isNotInvoiceIssuer: false,
          idType: '',
          bank_name: '',
          branch_name: '',
          account_type: 'futsu',
          account_number: '',
          account_holder: '',
          address: '',
          line_appraisal_code: ''
        },
        validationSchema: formSchema,
        onSubmit: async (values) => {
          if (convertingImageSide) return
          // 書類省略可否は初期情報APIだけでなく、送信時にもバックエンドが再判定する。
          if (identityInfo.document_required && !values.idType) {
            formik.setFieldError('idType', '身分証明書の種類を選択して下さい')
            return
          }
          if (identityInfo.document_required && !frontId) {
            setFrontIdError('本人確認書類（表）のアップロードが必要です');
            return;
          } else {
            setFrontIdError('');
          }
          // マイナンバー以外の場合は裏面必須チェック
          if (identityInfo.document_required && values.idType !== 'my_number' && !backId) {
            setBackIdError('本人確認書類（裏）のアップロードが必要です');
            return;
          } else {
            setBackIdError('');
          }

          // 申込氏名(セイ+メイ) と 口座名義の一致チェック（フロントのみ）
          const normalizeKana = (s) => {
            if (!s) return ''
            let t = s.normalize('NFKC')
            // ひらがな → カタカナ
            t = t.replace(/[\u3041-\u3096]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) + 0x60))
            // スペース類削除（半角/全角）
            t = t.replace(/[\s\u3000]/g, '')
            return t
          }
          const nameKana = normalizeKana(`${values.sei}${values.mei}`)
          const holderKana = normalizeKana(values.account_holder)
          if (nameKana !== holderKana) {
            setNameMismatchError('口座名義と申込時のお名前（セイ・メイ）が一致しません')
            return
          } else {
            setNameMismatchError('')
          }
          const tokenStr = localStorage.getItem('accountInfo')
          const token = tokenStr ? JSON.parse(tokenStr).access : null
          if (token) {
            baseAxios.defaults.headers.common['Authorization'] = `Bearer ${token}`
          }

          // Purchaseと振込口座をバックエンドの同一トランザクションで保存する
          const formData = new FormData();
          Object.entries(values).forEach(([key, value]) => {
            formData.append(key, value);
          });
          formData.set('terms_accepted', values.agreeToTerms)
          formData.set(
            'invoice_registration_status',
            values.isNotInvoiceIssuer ? 'not_registered' : 'unknown'
          )
          if (values.idType) {
            formData.set('idType', values.idType)
            formData.set('id_type', values.idType)
          }
          if (frontId) formData.append('front_id', frontId);
          if (values.idType !== 'my_number' && backId) formData.append('back_id', backId);
          const birthday = `${values.year}-${values.month.padStart(2, '0')}-${values.day.padStart(2, '0')}`;
          formData.append('birthday', birthday)
          dispatch(post_purchase(formData))
        },
      });

    const lookupAddressByPostalCode = async () => {
      const normalizedPostalcode = String(formik.values.postalcode || '').replace(/-/g, '')
      if (!/^\d{7}$/.test(normalizedPostalcode)) {
        setPostalLookupError('郵便番号を半角数字7桁で入力してください。')
        return
      }
      setPostalLookupLoading(true)
      setPostalLookupError('')
      try {
        const response = await axios.get(
          `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${normalizedPostalcode}`,
          {adapter: axiosJsonAdapter},
        )
        const result = response.data && response.data.results && response.data.results[0]
        if (!result) {
          setPostalLookupError('郵便番号から住所を取得できませんでした。郵便番号をご確認ください。')
          return
        }
        formik.setFieldValue('postalcode', normalizedPostalcode)
        formik.setFieldValue('prefecture', result.address1 || '')
        formik.setFieldValue('region', result.address2 || '')
        formik.setFieldValue('address_line', result.address3 || '')
      } catch (lookupError) {
        setPostalLookupError('住所検索に失敗しました。時間をおいて再度お試しください。')
      } finally {
        setPostalLookupLoading(false)
      }
    }

    // 会員本人のAccount → 現在のAdress → 直近Purchase/口座の順で初期入力する。
    // 本人確認書類の省略可否も同じAPIから受けるが、最終判定は申込API側で再実施する。
    useEffect(() => {
        const tokenStr = localStorage.getItem('accountInfo')
        const token = tokenStr ? JSON.parse(tokenStr).access : null
        if (token && accountInfo) {
            try{
                baseAxios.defaults.headers.common['Authorization'] = `Bearer ${token}`
                baseAxios.get('/api/inventory/purchase/form-initial/')
                .then((res) => {
                    const data = res.data
                    const birthday = data.previous_purchase && data.previous_purchase.birthday
                        ? data.previous_purchase.birthday.split('-') : ['', '', '']
                    formik.setValues({
                        ...formik.values,
                        first_name: data.account.first_name || '',
                        last_name: data.account.last_name || '',
                        email: data.account.email || '',
                        phone_number: data.account.phone_number || '',
                        sei: data.previous_purchase?.sei || '',
                        mei: data.previous_purchase?.mei || '',
                        year: birthday[0] || '',
                        month: birthday[1] ? String(Number(birthday[1])) : '',
                        day: birthday[2] ? String(Number(birthday[2])) : '',
                        age: data.previous_purchase?.age || '',
                        job: data.previous_purchase?.job || '',
                        address: data.address?.id || '',
                        postalcode: data.address?.postalcode || '',
                        prefecture: data.address?.prefecture || '',
                        region: data.address?.region || '',
                        address_line: data.address?.address_line || '',
                        building_name: data.address?.building_name || '',
                        bank_name: data.bank_account?.bank_name || '',
                        branch_name: data.bank_account?.branch_name || '',
                        account_type: data.bank_account?.account_type || 'futsu',
                        account_number: data.bank_account?.account_number || '',
                        account_holder: data.bank_account?.account_holder || '',
                    })
                    setIdentityInfo(data.identity)
                    if (!data.identity.document_required) {
                        setIdentityBaseline({
                            first_name: data.account.first_name || '',
                            last_name: data.account.last_name || '',
                            postalcode: data.address?.postalcode || '',
                            prefecture: data.address?.prefecture || '',
                            region: data.address?.region || '',
                            address_line: data.address?.address_line || '',
                            building_name: data.address?.building_name || '',
                        })
                    }
                })
                .catch(() => { /* 初期情報を取得できない場合は安全側として書類必須のままにする */ })
            }catch(e){ /* no-op */ }
        }
    }, [accountInfo])

    // 確認済みの氏名・住所をフォーム上で変更した時点で、安全側に倒して書類を再要求する。
    useEffect(() => {
        if (!identityBaseline) return
        const current = {
            first_name: formik.values.first_name,
            last_name: formik.values.last_name,
            postalcode: formik.values.postalcode,
            prefecture: formik.values.prefecture,
            region: formik.values.region,
            address_line: formik.values.address_line,
            building_name: formik.values.building_name,
        }
        const changed = Object.keys(identityBaseline).some(
            (key) => String(identityBaseline[key] || '').trim() !== String(current[key] || '').trim()
        )
        setIdentityInfo((previous) => ({
            ...previous,
            document_required: changed,
            note: changed
                ? '確認済みの氏名または住所から変更されたため、本人確認書類が必要です。'
                : '確認済みの氏名・住所と一致するため、会員ログインで本人確認を再利用します。',
        }))
    }, [
        identityBaseline, formik.values.first_name, formik.values.last_name,
        formik.values.postalcode, formik.values.prefecture, formik.values.region,
        formik.values.address_line, formik.values.building_name,
    ])

    headRewrite(title, description, keyword)

    const postalAddressFields = (
        <>
            <Grid item xs={8} sm={9}>
                <TextField
                    fullWidth
                    id="postalcode"
                    name="postalcode"
                    label="郵便番号"
                    value={formik.values.postalcode}
                    onChange={(event) => {
                        formik.handleChange(event)
                        if (postalLookupError) setPostalLookupError('')
                    }}
                    error={formik.touched.postalcode && Boolean(formik.errors.postalcode)}
                    helperText={formik.touched.postalcode && formik.errors.postalcode}
                />
            </Grid>
            <Grid item xs={4} sm={3}>
                <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    className={classes.button}
                    onClick={lookupAddressByPostalCode}
                    disabled={postalLookupLoading}
                >
                    {postalLookupLoading ? '検索中…' : '住所を検索'}
                </Button>
            </Grid>
            {postalLookupError && (
                <Grid item xs={12}>
                    <Typography variant="caption" color="error">{postalLookupError}</Typography>
                </Grid>
            )}
            <Grid item xs={12}>
                <TextField fullWidth id="prefecture" name="prefecture" label="都道府県"
                    value={formik.values.prefecture} onChange={formik.handleChange}
                    error={formik.touched.prefecture && Boolean(formik.errors.prefecture)}
                    helperText={formik.touched.prefecture && formik.errors.prefecture}/>
            </Grid>
            <Grid item xs={12}>
                <TextField fullWidth id="region" name="region" label="市区町村"
                    value={formik.values.region} onChange={formik.handleChange}
                    error={formik.touched.region && Boolean(formik.errors.region)}
                    helperText={formik.touched.region && formik.errors.region}/>
            </Grid>
            <Grid item xs={12}>
                <TextField fullWidth id="address_line" name="address_line" label="町域・丁・番地・号"
                    value={formik.values.address_line} onChange={formik.handleChange}
                    error={formik.touched.address_line && Boolean(formik.errors.address_line)}
                    helperText={(formik.touched.address_line && formik.errors.address_line) || '郵便番号検索後、丁・番地・号を追加入力してください。'}/>
            </Grid>
            <Grid item xs={12}>
                <TextField fullWidth id="building_name" name="building_name" label="建物名・部屋番号（任意）"
                    value={formik.values.building_name} onChange={formik.handleChange}
                    error={formik.touched.building_name && Boolean(formik.errors.building_name)}
                    helperText={formik.touched.building_name && formik.errors.building_name}/>
            </Grid>
        </>
    )

    const bankAccountFields = (
        <>
            <Grid item xs={12}>
                <Typography variant="h6" component="p" style={{fontWeight: 'bold', fontSize: '16px'}}>
                    口座情報（買取代金の振込先）
                </Typography>
                <Typography variant="body2" component="p" style={{marginTop: '2px'}}>
                    ※口座名義と申し込み時のお名前が一致する必要がございます
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField fullWidth id="bank_name" name="bank_name" label="銀行名（例：三井住友銀行）"
                    value={formik.values.bank_name} onChange={formik.handleChange}
                    error={formik.touched.bank_name && Boolean(formik.errors.bank_name)}
                    helperText={formik.touched.bank_name && formik.errors.bank_name}/>
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField fullWidth id="branch_name" name="branch_name" label="支店名（例：渋谷支店）"
                    value={formik.values.branch_name} onChange={formik.handleChange}
                    error={formik.touched.branch_name && Boolean(formik.errors.branch_name)}
                    helperText={formik.touched.branch_name && formik.errors.branch_name}/>
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField select fullWidth id="account_type" name="account_type" label="口座種別"
                    value={formik.values.account_type} onChange={formik.handleChange}
                    error={formik.touched.account_type && Boolean(formik.errors.account_type)}
                    helperText={formik.touched.account_type && formik.errors.account_type}>
                    <MenuItem value={'futsu'}>普通</MenuItem>
                    <MenuItem value={'toza'}>当座</MenuItem>
                </TextField>
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField fullWidth id="account_number" name="account_number" label="口座番号（7桁）"
                    value={formik.values.account_number} onChange={formik.handleChange}
                    error={formik.touched.account_number && Boolean(formik.errors.account_number)}
                    helperText={formik.touched.account_number && formik.errors.account_number}/>
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField fullWidth id="account_holder" name="account_holder" label="口座名義（カタカナ）"
                    value={formik.values.account_holder} onChange={formik.handleChange}
                    error={formik.touched.account_holder && Boolean(formik.errors.account_holder)}
                    helperText={formik.touched.account_holder && formik.errors.account_holder}/>
            </Grid>
            {nameMismatchError && (
                <Grid item xs={12}>
                    <Typography variant="body2" color="error">{nameMismatchError}</Typography>
                </Grid>
            )}
        </>
    )

    const applicationConfirmationFields = (
        <>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    id="line_appraisal_code"
                    name="line_appraisal_code"
                    label="LINE査定コード（任意）"
                    value={formik.values.line_appraisal_code}
                    onChange={formik.handleChange}
                    error={formik.touched.line_appraisal_code && Boolean(formik.errors.line_appraisal_code)}
                    helperText={
                        (formik.touched.line_appraisal_code && formik.errors.line_appraisal_code)
                        || '発送前にLINE査定をご利用になった方だけ、LINEで案内されたコードを入力してください。未利用の場合は空欄で申し込めます。'
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            className={classes.checkbox}
                            id="isNotInvoiceIssuer"
                            name="isNotInvoiceIssuer"
                            color="#bdbdbd"
                            style={{backgroundColor: 'initial'}}
                            checked={formik.values.isNotInvoiceIssuer}
                            onChange={formik.handleChange}
                        />
                    }
                    label={
                        <Typography variant="body2">
                            私は適格請求書発行事業者（インボイス登録事業者）ではありません。
                        </Typography>
                    }
                />
                {formik.touched.isNotInvoiceIssuer && formik.errors.isNotInvoiceIssuer && (
                    <Typography variant="caption" color="error" component="p">
                        {formik.errors.isNotInvoiceIssuer}
                    </Typography>
                )}
                <Typography variant="body2" component="p">
                    インボイス登録事業者としての買取をご希望の場合は、通常の宅配買取フォームを利用せず、
                    <a href="https://line.me/R/ti/p/@240yzqkh" target="_blank" rel="noopener noreferrer">LINE</a>
                    または<a href="https://enclopedia.jp/contact/" target="_blank" rel="noopener noreferrer">メール</a>
                    からお問い合わせください。
                </Typography>
            </Grid>
        </>
    )
    
    //アカウント登録を行っている場合の住所に関してはAdressモデルに登録を行うようにする
    //お申込み後に発送場所情報をメールにて送信する
    //入力した住所と身分確認証の住所が一致する必要がある
    //買取確認の際にマイナンバーカードの場合は裏面の提出をしなくて良い
    return(
        <>
        {   
            loading ?
                <div className={classes.loader}>
                    <Loader />
                </div>
            :
            purchase ?
                <div className={classes.error_container}>
                    <Typography  variant="subtitle1" component="p" align='center'>
                        {`申し込みが完了しました.\n
                        ご入力頂いたメールアドレスにメッセージを送信しましたのでご確認ください。
                        `}
                    </Typography>
                </div>
            :
            <div className={classes.root}>
                <Typography variant="h1" component="h1" className={classes.title}>
                    お買取申込フォーム
                </Typography>
                <Container maxWidth="md" className={classes.form}>
                    {error && (
                        <Typography variant="body2" color="error" component="p" style={{marginBottom: '16px'}}>
                            {error}
                        </Typography>
                    )}
                    <form onSubmit={formik.handleSubmit} noValidate>
                    {accountInfo && (
                        <Typography variant="body2" color={identityInfo.document_required ? 'textPrimary' : 'primary'} style={{marginBottom: '16px'}}>
                            本人確認：{identityInfo.note}
                        </Typography>
                    )}
                    {accountInfo ? 
                    //アカウントが存在する場合
                    <Grid container spacing={2}>

                        <Grid item xs={6} sm={6}>
                            <TextField
                            fullWidth
                            id="sei"
                            name="sei"
                            label="セイ"
                            value={formik.values.sei}
                            onChange={formik.handleChange}
                            error={formik.touched.sei && Boolean(formik.errors.sei)}
                            helperText={formik.touched.sei && formik.errors.sei}
                            />
                        </Grid>

                        <Grid item xs={6} sm={6}>
                            <TextField
                            fullWidth
                            id="mei"
                            name="mei"
                            label="メイ"
                            value={formik.values.mei}
                            onChange={formik.handleChange}
                            error={formik.touched.mei && Boolean(formik.errors.mei)}
                            helperText={formik.touched.mei && formik.errors.mei}
                            />
                        </Grid>

                        <Grid item xs={6} sm={6}>
                            <TextField
                            fullWidth
                            id="first_name"
                            name="first_name"
                            label="名"
                            value={formik.values.first_name}
                            onChange={formik.handleChange}
                            error={formik.touched.first_name && Boolean(formik.errors.first_name)}
                            helperText={formik.touched.first_name && formik.errors.first_name}
                            />
                        </Grid>

                        <Grid item xs={6} sm={6}>
                            <TextField
                                fullWidth
                                id="last_name"
                                name="last_name"
                                label="姓"
                                value={formik.values.last_name}
                                onChange={formik.handleChange}
                                error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                                helperText={formik.touched.last_name && formik.errors.last_name}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="email"
                                name="email"
                                label="メールアドレス"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="phone_number"
                                name="phone_number"
                                label="電話番号"
                                value={formik.values.phone_number}
                                onChange={formik.handleChange}
                                error={formik.touched.phone_number && Boolean(formik.errors.phone_number)}
                                helperText={formik.touched.phone_number && formik.errors.phone_number}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <Typography variant="body1">生年月日</Typography>
                        </Grid>
                            <Grid item xs={4}>
                            <TextField
                                select
                                fullWidth
                                label="年"
                                name="year"
                                value={formik.values.year}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.year && Boolean(formik.errors.year)}
                                helperText={formik.touched.year && formik.errors.year}
                                SelectProps={{ native: true }}
                            >
                                {Array.from({ length: 100 }, (_, i) => {
                                const year = new Date().getFullYear() - i;
                                return <option key={year} value={year}>{year}</option>;
                                })}
                            </TextField>
                            </Grid>

                            <Grid item xs={4}>
                            <TextField
                                select
                                fullWidth
                                label="月"
                                name="month"
                                value={formik.values.month}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.month && Boolean(formik.errors.month)}
                                helperText={formik.touched.month && formik.errors.month}
                                SelectProps={{ native: true }}
                            >
                                {Array.from({ length: 12 }, (_, i) => (
                                <option key={i + 1} value={i + 1}>{i + 1}</option>
                                ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                select
                                fullWidth
                                label="日"
                                name="day"
                                value={formik.values.day}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.day && Boolean(formik.errors.day)}
                                helperText={formik.touched.day && formik.errors.day}
                                SelectProps={{ native: true }}
                            >
                                {Array.from({ length: 31 }, (_, i) => (
                                <option key={i + 1} value={i + 1}>{i + 1}</option>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="age"
                                name="age"
                                label="年齢"
                                type="number"
                                value={formik.values.age}
                                onChange={formik.handleChange}
                                error={formik.touched.age && Boolean(formik.errors.age)}
                                helperText={formik.touched.age && formik.errors.age}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                select
                                fullWidth
                                id="job"
                                name="job"
                                label="職業"
                                value={formik.values.job}
                                onChange={formik.handleChange}
                                error={formik.touched.job && Boolean(formik.errors.job)}
                                helperText={formik.touched.job && formik.errors.job}
                                variant="outlined"
                                margin="normal"
                            >
                                {JOB_OPTIONS.map((option) => (
                                    <MenuItem key={option.key} value={option.label}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        {postalAddressFields}

                        <Grid item xs={12} style={{display: identityInfo.document_required ? 'block' : 'none'}}>
                            <TextField
                                select
                                fullWidth
                                id="idType"
                                name="idType"
                                label="身分証明書の種類"
                                value={formik.values.idType}
                                onChange={(e) => {
                                    formik.handleChange(e)
                                    if (e.target.value === 'my_number') {
                                        setBackId(null)
                                        setBackIdError('')
                                    }
                                }}
                                error={formik.touched.idType && Boolean(formik.errors.idType)}
                                helperText={formik.touched.idType && formik.errors.idType}
                                variant="outlined"
                                margin="normal"
                                >
                                {ID_TYPE_OPTIONS.map((option) => (
                                <MenuItem key={option.key} value={option.key}>
                                    {option.label}
                                </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        {identityInfo.document_required && formik.values.idType === 'my_number' && (
                          <Grid item xs={12}>
                            <Typography variant="body2" color="error">
                              マイナンバーカードを選択した場合は、裏面の個人番号（12桁）は撮影・アップロードしないでください。表面のみご提出ください。
                            </Typography>
                          </Grid>
                        )}

                        {/* 本人確認書類 */}
                        <Grid item xs={12} style={{display: identityInfo.document_required ? 'block' : 'none'}}>
                            <Typography>本人確認書類（表）</Typography>
                            <input
                                id="front_id"
                                name="front_id"
                                type="file"
                                accept={ID_IMAGE_ACCEPT}
                                onChange={(event) => handleIdentityImageChange('front', event)}
                            />
                            <Typography variant="caption" component="p">JPEG・PNG・WebP・HEIC・HEIF／1枚5MB以下（表裏合計10MB以下）</Typography>
                            {convertingImageSide === 'front' && (
                              <Typography variant="caption" color="primary">HEIC・HEIF画像をJPEGへ変換しています…</Typography>
                            )}
                            {frontIdError && (
                              <Typography variant="caption" color="error">{frontIdError}</Typography>
                            )}
                        </Grid>

                        {/*マイナンバーカードの場合には裏面発揚ない、*/}
                        {
                        !identityInfo.document_required || formik.values.idType === 'my_number'?
                        ''
                        :
                        <Grid item xs={12}>
                        <Typography>本人確認書類（裏）</Typography>
                        <input
                            id="back_id"
                            name="back_id"
                            type="file"
                            accept={ID_IMAGE_ACCEPT}
                            onChange={(event) => handleIdentityImageChange('back', event)}
                        />
                        {convertingImageSide === 'back' && (
                          <Typography variant="caption" color="primary">HEIC・HEIF画像をJPEGへ変換しています…</Typography>
                        )}
                        {backIdError && (
                          <Typography variant="caption" color="error">{backIdError}</Typography>
                        )}
                        </Grid>
                        }

                        {bankAccountFields}

                        {applicationConfirmationFields}

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    className={classes.checkbox}
                                    id="agreeToTerms"
                                    name="agreeToTerms"
                                    color='#bdbdbd'
                                    style={{backgroundColor: 'initial'}}
                                    checked={formik.values.agreeToTerms}
                                    onChange={formik.handleChange}
                                />
                                }
                                label={
                                <Typography variant="body2">
                                    下記買取規約に同意します
                                </Typography>
                                }
                            />
                            {formik.touched.agreeToTerms && formik.errors.agreeToTerms && (
                                <Typography variant="caption" color="error">
                                {formik.errors.agreeToTerms}
                                </Typography>
                            )}
                        </Grid>

                        <Grid item xs={12} className={classes.agreement}>
                            <Typography className={classes.agreement_text} variant={"p"} component={"p"}>
                                {`
                                お買取成立後は当店に所有権が移行しますので、お客様都合での返品・キャンセルは一切お受けできかねます。\n
                                古物営業法15条に則り、盗品の疑いがある場合はお買取成立後でも警察当局へ報告義務がございます。\n
                                お買い取り商品に【故障・不具合・盗品・詐欺・弊社規定外品】などの事実、又は疑いがある場合は、
                                所有権移行完了後であっても全額返金させて頂く場合が御座いますのでご了承ください。\n
                                買取フォームにご記入いただきました情報は、当店が定めるプライバシーポリシーの利用目的の範囲内で利用いたします。\n

                                注意事項\n
                                ①買取対象外ブランド\n
                                ファストファッション系ブランドなど\n
                                ②偽造品・コピー品(1点もお値段がつかなかった場合、弊社基準外のお品物はお客様負担でのご返送になりますので予めご了承くださいませ)
                                着物類\n
                                ③電池切れの時計\n
                                ④インディアンジュエリー\n
                                ⑤家具・家電・カメラなど\n
                                `}
                            </Typography>
                        </Grid>

                        {/* 送信ボタン */}
                        <Grid item xs={12}>
                            <Button 
                            className={classes.button} 
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={!formik.values.agreeToTerms || !formik.values.isNotInvoiceIssuer || hasIdentityImageError || Boolean(convertingImageSide)}
                            >
                                送信する
                            </Button>
                        </Grid>
                    </Grid>
                    :
                    //アカウントが存在しない場合のForm（基本的にリダイレクトされ表示されない想定）
                    <Grid container spacing={2}>

                        <Grid item xs={6} sm={6}>
                            <TextField
                            fullWidth
                            id="sei"
                            name="sei"
                            label="セイ"
                            value={formik.values.sei}
                            onChange={formik.handleChange}
                            error={formik.touched.sei && Boolean(formik.errors.sei)}
                            helperText={formik.touched.sei && formik.errors.sei}
                            />
                        </Grid>

                        <Grid item xs={6} sm={6}>
                            <TextField
                            fullWidth
                            id="mei"
                            name="mei"
                            label="メイ"
                            value={formik.values.mei}
                            onChange={formik.handleChange}
                            error={formik.touched.mei && Boolean(formik.errors.mei)}
                            helperText={formik.touched.mei && formik.errors.mei}
                            />
                        </Grid>

                        <Grid item xs={6} sm={6}>
                            <TextField
                                fullWidth
                                id="last_name"
                                name="last_name"
                                label="姓"
                                value={formik.values.last_name}
                                onChange={formik.handleChange}
                                error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                                helperText={formik.touched.last_name && formik.errors.last_name}
                            />
                        </Grid>

                        <Grid item xs={6} sm={6}>
                            <TextField
                            fullWidth
                            id="first_name"
                            name="first_name"
                            label="名"
                            value={formik.values.first_name}
                            onChange={formik.handleChange}
                            error={formik.touched.first_name && Boolean(formik.errors.first_name)}
                            helperText={formik.touched.first_name && formik.errors.first_name}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="email"
                                name="email"
                                label="メールアドレス"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="phone_number"
                                name="phone_number"
                                label="電話番号"
                                value={formik.values.phone_number}
                                onChange={formik.handleChange}
                                error={formik.touched.phone_number && Boolean(formik.errors.phone_number)}
                                helperText={formik.touched.phone_number && formik.errors.phone_number}
                            />
                        </Grid>
                        
                        <Grid item xs={12} sm={12}>
                            <Typography variant="body1">生年月日</Typography>
                        </Grid>
                            <Grid item xs={4}>
                            <TextField
                                select
                                fullWidth
                                label="年"
                                name="year"
                                value={formik.values.year}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.year && Boolean(formik.errors.year)}
                                helperText={formik.touched.year && formik.errors.year}
                                SelectProps={{ native: true }}
                            >
                                {Array.from({ length: 100 }, (_, i) => {
                                const year = new Date().getFullYear() - i;
                                return <option key={year} value={year}>{year}</option>;
                                })}
                            </TextField>
                            </Grid>

                            <Grid item xs={4}>
                            <TextField
                                select
                                fullWidth
                                label="月"
                                name="month"
                                value={formik.values.month}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.month && Boolean(formik.errors.month)}
                                helperText={formik.touched.month && formik.errors.month}
                                SelectProps={{ native: true }}
                            >
                                {Array.from({ length: 12 }, (_, i) => (
                                <option key={i + 1} value={i + 1}>{i + 1}</option>
                                ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={4}>
                            <TextField
                                select
                                fullWidth
                                label="日"
                                name="day"
                                value={formik.values.day}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.day && Boolean(formik.errors.day)}
                                helperText={formik.touched.day && formik.errors.day}
                                SelectProps={{ native: true }}
                            >
                                {Array.from({ length: 31 }, (_, i) => (
                                <option key={i + 1} value={i + 1}>{i + 1}</option>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="age"
                                name="age"
                                label="年齢"
                                type="number"
                                value={formik.values.age}
                                onChange={formik.handleChange}
                                error={formik.touched.age && Boolean(formik.errors.age)}
                                helperText={formik.touched.age && formik.errors.age}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                select
                                fullWidth
                                id="job"
                                name="job"
                                label="職業"
                                value={formik.values.job}
                                onChange={formik.handleChange}
                                error={formik.touched.job && Boolean(formik.errors.job)}
                                helperText={formik.touched.job && formik.errors.job}
                                variant="outlined"
                                margin="normal"
                            >
                                {JOB_OPTIONS.map((option) => (
                                    <MenuItem key={option.key} value={option.label}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        {postalAddressFields}

                        <Grid item xs={12} style={{display: identityInfo.document_required ? 'block' : 'none'}}>
                            <TextField
                                select
                                fullWidth
                                id="idType"
                                name="idType"
                                label="身分証明書の種類"
                                value={formik.values.idType}
                                onChange={(e) => {
                                    formik.handleChange(e)
                                    if (e.target.value === 'my_number') {
                                        setBackId(null)
                                        setBackIdError('')
                                    }
                                }}
                                error={formik.touched.idType && Boolean(formik.errors.idType)}
                                helperText={formik.touched.idType && formik.errors.idType}
                                variant="outlined"
                                margin="normal"
                                >
                                {ID_TYPE_OPTIONS.map((option) => (
                                <MenuItem key={option.key} value={option.key}>
                                    {option.label}
                                </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        {identityInfo.document_required && formik.values.idType === 'my_number' && (
                          <Grid item xs={12}>
                            <Typography variant="body2" color="error">
                              マイナンバーカードを選択した場合は、裏面の個人番号（12桁）は撮影・アップロードしないでください。表面のみご提出ください。
                            </Typography>
                          </Grid>
                        )}

                        {/* 本人確認書類 */}
                        <Grid item xs={12} style={{display: identityInfo.document_required ? 'block' : 'none'}}>
                            <Typography>本人確認書類（表）</Typography>
                            <input
                                id="front_id"
                                name="front_id"
                                type="file"
                                accept={ID_IMAGE_ACCEPT}
                                onChange={(event) => handleIdentityImageChange('front', event)}
                            />
                            <Typography variant="caption" component="p">JPEG・PNG・WebP・HEIC・HEIF／1枚5MB以下（表裏合計10MB以下）</Typography>
                            {convertingImageSide === 'front' && (
                              <Typography variant="caption" color="primary">HEIC・HEIF画像をJPEGへ変換しています…</Typography>
                            )}
                            {frontIdError && (
                              <Typography variant="caption" color="error">{frontIdError}</Typography>
                            )}
                        </Grid>

                        {/*マイナンバーカードの場合には裏面発揚ない、*/}
                        {
                        !identityInfo.document_required || formik.values.idType === 'my_number'
                        ?
                        ''
                        :
                        <Grid item xs={12}>
                        <Typography>本人確認書類（裏）</Typography>
                        <input
                            id="back_id"
                            name="back_id"
                            type="file"
                            accept={ID_IMAGE_ACCEPT}
                            onChange={(event) => handleIdentityImageChange('back', event)}
                        />
                        {convertingImageSide === 'back' && (
                          <Typography variant="caption" color="primary">HEIC・HEIF画像をJPEGへ変換しています…</Typography>
                        )}
                        {backIdError && (
                          <Typography variant="caption" color="error">{backIdError}</Typography>
                        )}
                        </Grid>
                        }

                        {bankAccountFields}

                        {applicationConfirmationFields}

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    className={classes.checkbox}
                                    id="agreeToTerms"
                                    name="agreeToTerms"
                                    color='#bdbdbd'
                                    style={{backgroundColor: 'initial'}}
                                    checked={formik.values.agreeToTerms}
                                    onChange={formik.handleChange}
                                />
                                }
                                label={
                                <Typography variant="body2">
                                    下記買取規約に同意します
                                </Typography>
                                }
                            />
                            {formik.touched.agreeToTerms && formik.errors.agreeToTerms && (
                                <Typography variant="caption" color="error">
                                {formik.errors.agreeToTerms}
                                </Typography>
                            )}
                        </Grid>
                        
                        <Grid item xs={12} className={classes.agreement}>
                            <Typography className={classes.agreement_text} variant={"p"} component={"p"}>
                                {`
                                お買取成立後は当店に所有権が移行しますので、お客様都合での返品・キャンセルは一切お受けできかねます。\n
                                古物営業法15条に則り、盗品の疑いがある場合はお買取成立後でも警察当局へ報告義務がございます。\n
                                お買い取り商品に【故障・不具合・盗品・詐欺・弊社規定外品】などの事実、又は疑いがある場合は、
                                所有権移行完了後であっても全額返金させて頂く場合が御座いますのでご了承ください。\n
                                買取フォームにご記入いただきました情報は、当店が定めるプライバシーポリシーの利用目的の範囲内で利用いたします。\n

                                注意事項\n
                                ①買取対象外ブランド\n
                                ファストファッション系ブランドなど\n
                                ②偽造品・コピー品(1点もお値段がつかなかった場合、弊社基準外のお品物はお客様負担でのご返送になりますので予めご了承くださいませ)
                                着物類、\n
                                ③電池切れの時計\n
                                ④インディアンジュエリー\n
                                ⑤家具・家電・カメラなど\n
                                `}
                            </Typography>
                        </Grid>
                        
                        {/* 送信ボタン */}
                        <Grid item xs={12}>
                            <Button 
                            className={classes.button} 
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={!formik.values.agreeToTerms || !formik.values.isNotInvoiceIssuer || hasIdentityImageError || Boolean(convertingImageSide)}
                            >
                                送信する
                            </Button>
                        </Grid>
                    </Grid>
                    }
                    </form>
                </Container>
            </div>
        }
        </>
    )
}

export default KaitoriFormScreen
